import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, ScanCommand } from "@aws-sdk/lib-dynamodb";
import { exchangeCodeForToken } from "./tokenExchange";


const dynamoClient = new DynamoDBClient({ region: "us-east-1" });
const docClient = DynamoDBDocumentClient.from(dynamoClient);
// Get token dynamically when function is called instead of on module load
const getBearerToken = () => localStorage.getItem('idToken');
// const LB_URL = 'http://eloquenceSocketLB-928202644.us-east-1.elb.amazonaws.com/api/calls';

// staging one is below
// const LB_URL = 'https://dfpegpq4ou0d8.cloudfront.net/api';
// prod url
const LB_URL = 'https://d1u3pka9oxzjz9.cloudfront.net/api';


// api gateway
// const LB_URL = 'https://ro81m77q79.execute-api.us-east-1.amazonaws.com/prod/eloquenceAPI';
// cloudfront
// const LB_URL = 'https://d3hhmd8ops80o6.cloudfront.net';

export async function getMeetingsFromDynamoDB() {
  console.log("making API call...")
  const bearerToken = getBearerToken();
  console.log("Current token:", bearerToken);
  try {
    const response = await fetch(LB_URL + "/calls", {
      method: 'get',
      headers: new Headers({
        'X-MyApp-Authorization': 'Bearer ' + bearerToken,
      }),
    });

    console.log("API response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API response data:", data)
    return data || [];
  } catch (error) {
    console.error("Error fetching meetings:", error);
    throw error;
  }
}

export async function getMeetingFromDynamoDBByID(uuid) {
  console.log("making API call...")
  const bearerToken = getBearerToken();
  console.log("Current token:", bearerToken);
  try {
    const response = await fetch(LB_URL + "/call/" + uuid, {
      method: 'get',
      headers: new Headers({
        'X-MyApp-Authorization': 'Bearer ' + bearerToken,
      }),
    });

    console.log("API response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("API response data:", data)
    return data || [];
  } catch (error) {
    console.error("Error fetching meetings:", error);
    throw error;
  }
}

export function findMeeting(meetings, id) {
  for (let meeting of meetings) {
    if (meeting.uuid == id) {
      meeting.promptOutput = JSON.parse(meeting.promptOutput);
      return meeting;
    }
  }
}

export function parseMeeting(meeting) {
  meeting.promptOutput = JSON.parse(meeting.promptOutput);

  return meeting;
}

export async function getPresignedUrl(file, meetingType = 'General') {
  try {
    // Validate file type
    if (!file.name.toLowerCase().endsWith('.mp4')) {
      throw new Error('Only MP4 files are allowed');
    }

    const bearerToken = getBearerToken();
    const response = await fetch(LB_URL + "/upload-url", {
      method: 'POST',
      headers: new Headers({
        'X-MyApp-Authorization': 'Bearer ' + bearerToken,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        fileName: file.name,
        contentType: file.type || 'video/mp4',
        meetingType: meetingType
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting presigned URL:", error);
    throw error;
  }
}

export async function deleteMeeting(uuid) {
  try {
    const bearerToken = getBearerToken();
    const response = await fetch(`${LB_URL}/delete/${uuid}`, {
      method: 'DELETE',
      headers: new Headers({
        'X-MyApp-Authorization': 'Bearer ' + bearerToken,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Error deleting meeting:", error);
    throw error;
  }
}
